export default "__VITE_ASSET__FS82Rhrx__"